import { Field } from 'components/Field'
import { FormFieldProps } from 'components/FormFields'
import { Field as FormikField, FieldConfig } from 'formik'
import React from 'react'
import styled, { css } from 'styled-components'
import { FormikFieldStatus } from '../../Formik.field.status'

export const formikEmailStyles = css``

const FormikEmailView = styled.div`
	${formikEmailStyles}
`

export type FormikEmailProps = Omit<FieldConfig<string>, 'type'> & {
	name: string
	config: FormFieldProps
	className?: string
}

export const FormikEmail = ({
	config: fieldProps,
	name,
	className,
	...props
}: FormikEmailProps) => {
	return (
		<FormikEmailView className={`formik-email${className ? ` ${className}` : ''}`}>
			<Field {...fieldProps} name={name}>
				<FormikField {...props} type='email' as={null} name={name} />
				<FormikFieldStatus name={name} />
			</Field>
		</FormikEmailView>
	)
}
